import { ICreateCardPendencyPaymentDTO } from 'modules/customer/domain/dtos';
import { IContractPaymentsRepository } from 'modules/customer/domain/repositories';
import { UseCaseError } from 'shared/domain/errors';
import { getCardFlagFrom } from 'shared/domain/helpers';

export class CreateCardPendencyPaymentUseCase {
  constructor(
    private contractPaymentsRepository: IContractPaymentsRepository,
  ) {}

  public async execute({ process, card, link }: ICreateCardPendencyPaymentDTO) {
    return this.contractPaymentsRepository.create({
      method: 'RECURRING_CARD',
      link,
      card: this.getCardParams(card),
      process,
    });
  }

  private getCardParams(card: ICreateCardPendencyPaymentDTO['card']) {
    if ('id' in card) return card;

    const flag = getCardFlagFrom(card.number);

    if (!flag) throw new UseCaseError('Unrecognized flag');

    return {
      ...card,
      flag,
    };
  }
}
